import { AppPath } from '../enums/AppPath'
import {
  BranchState,
  ConsignmentState,
  CreditState,
  DealState,
  MessageState,
  UserState,
  VehicleState,
} from '../enums/DocStates'

const tempData: {
  baseUrl: string
} = { baseUrl: import.meta.env.VITE_API_URL }
//} = { baseUrl: "http://veekls2-api-env-2.eba-mthmpvfc.us-east-1.elasticbeanstalk.com/api/" };
//} = { baseUrl: "http://localhost:3000/api/" };

const yapoUrl = import.meta.env.VITE_YAPO_API_URL
const chaUrl = import.meta.env.VITE_CHA_API_URL
const meliUrl = import.meta.env.VITE_MELI_API_URL

export const makeUrlDashboard = () => `${tempData.baseUrl}dashboard`

export const makeUrlEstimateCrea = () => {
  return `${tempData.baseUrl}estimate_crea`
}
export const makeUrlConsignmentCrea = () => {
  return `${tempData.baseUrl}consignment_crea`
}
export const makeUrlReservationCrea = () => {
  return `${tempData.baseUrl}reservation_crea`
}
export const makeUrlReservationEdit = () => {
  return `${tempData.baseUrl}reservation_edit`
}
export const makeUrlSalenoteCrea = () => {
  return `${tempData.baseUrl}salenote_crea_edit`
}

export const makeUrlSalenoteVoid = (): string => {
  return `${tempData.baseUrl}salenote_void`
}
export const makeUrlSalenoteReassign = (): string => {
  return `${tempData.baseUrl}salenote_reassign`
}
export const makeUrlSalenoteApprove = (): string => {
  return `${tempData.baseUrl}salenote_approve`
}
export const makeUrlSalenoteApproveDiscount = (): string => {
  return `${tempData.baseUrl}salenote_approve_discount`
}
export const makeUrlSettlementCrea = () => {
  return `${tempData.baseUrl}settlement_crea`
}
export const makeUrlPurchaseCrea = () => {
  return `${tempData.baseUrl}purchase_crea`
}
export const makeUrlActivityEdit = (modifica: boolean) => {
  return `${tempData.baseUrl}activity_edit/${modifica ? 'modify' : 'crea'}`
}
export const makeUrlSettlement = (id: string) => {
  return `${tempData.baseUrl}settlement_detail/${id}`
}
export const makeUrlPurchase = (id: string) => {
  return `${tempData.baseUrl}purchase_detail/${id}`
}
export const makeUrlPurchaseVoid = (): string => {
  return `${tempData.baseUrl}purchase_void`
}
export const makeUrlVehicle = (id: string): string => {
  return `${tempData.baseUrl}vehicle_detail/${id}`
}
export const makeUrlVehiclesByPlate = (organizationId: string, plate: string): string => {
  return `${tempData.baseUrl}vehicles/pag?organization=${organizationId}&plate=${plate}`
}
export const makeUrlPublishStatistics = (organizationId: string): string => {
  return `${tempData.baseUrl}publish/statistics/${organizationId}`
}
export const makeUrlEstimate = (id: string): string => {
  return `${tempData.baseUrl}estimate_detail/${id}`
}
export const makeUrlReservation = (id: string): string => {
  return `${tempData.baseUrl}reservation_detail/${id}`
}
export const makeUrlSalenote = (id: string): string => {
  return `${tempData.baseUrl}salenote_detail/${id}`
}
export const makeUrlEstimateVoid = (): string => {
  return `${tempData.baseUrl}estimate_void`
}
export const makeUrlEstimateExtend = (): string => {
  return `${tempData.baseUrl}estimate_extend`
}
export const makeUrlImage = (id: string): string => {
  return `${tempData.baseUrl}picture/${id}`
}
export const makeUrlImageAttachment = (id: string): string => {
  return `${tempData.baseUrl}picture/attachment/${id}`
}
export const makeUrlConsignment = (id: string): string => {
  return `${tempData.baseUrl}consignment_detail/${id}`
}
export const makeUrlConsignmentDb = (id: string): string => {
  return `${tempData.baseUrl}consignment_db/${id}`
}
export const makeUrlConsignmentArchive = (): string => {
  return `${tempData.baseUrl}consignment_archive`
}
export const makeUrlConsignmentPrice = (): string => {
  return `${tempData.baseUrl}consignment_price`
}
export const makeUrlMargins = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}margins?${params.toString()}`
}
export const makeUrlStocks = (organizationId: string): string => {
  return `${tempData.baseUrl}stocks/${organizationId}`
}
export const makeUrlPublishedStats = (organizationId: string): string => {
  return `${tempData.baseUrl}published/stats/${organizationId}`
}
export const makeUrlSalesTotals = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}sales_totals?${params.toString()}`
}
export const makeUrlCard = (path: AppPath, index: number, organizationId: string, external?: string): string => {
  let apiUrl = ''

  switch (path) {
    case AppPath.Estimates:
      apiUrl = `${tempData.baseUrl}estimates`

      if (index == 0) {
        apiUrl += '/vig'
      } else if (index == 1) {
        apiUrl += '/exp'
      } else if (index == 2) {
        apiUrl += '/nul'
      }
      apiUrl += '/' + organizationId
      break

    case AppPath.Consignments:
      apiUrl = `${tempData.baseUrl}consignments`

      if (index == ConsignmentState.Activo) {
        apiUrl += '/act'
      } else if (index == ConsignmentState.Nulo) {
        apiUrl += '/nul'
      } else if (index == ConsignmentState.Archivado) {
        apiUrl += '/arc'
      } else if (index == ConsignmentState.Liquidables) {
        apiUrl += '/liq'
      }
      apiUrl += '/' + organizationId
      break

    case AppPath.Reservations:
      apiUrl = `${tempData.baseUrl}reservations`

      if (index == 0) {
        apiUrl += '/act'
      } else if (index == 1) {
        apiUrl += '/com'
      } else if (index == 2) {
        apiUrl += '/arc'
      } else if (index == 3) {
        apiUrl += '/nul'
      }
      apiUrl += '/' + organizationId
      break
    case AppPath.SaleNotes:
      apiUrl = `${tempData.baseUrl}salenotes`

      if (index == 0) {
        apiUrl += '/pen'
      } else if (index == 1) {
        apiUrl += '/apr'
      } else if (index == 2) {
        apiUrl += '/nul'
      }
      apiUrl += '/' + organizationId
      break

    case AppPath.Settlements:
      apiUrl = `${tempData.baseUrl}settlements`

      if (index == 0) {
        apiUrl += '/act'
      } else if (index == 1) {
        apiUrl += '/nul'
      }
      apiUrl += '/' + organizationId
      break

    case AppPath.Purchases:
      apiUrl = `${tempData.baseUrl}purchases`

      if (index == 0) {
        apiUrl += '/val'
      } else if (index == 1) {
        apiUrl += '/nul'
      }
      apiUrl += '/' + organizationId
      break

    case AppPath.Vehicles:
      apiUrl = `${tempData.baseUrl}vehicles`

      switch (index) {
        case VehicleState.Publicados:
          apiUrl += '/pub'
          break
        case VehicleState.Pendientes:
          apiUrl += '/pen'
          break
        case VehicleState.Reservados:
          apiUrl += '/res'
          break
        case VehicleState.Vendidos:
          apiUrl += '/ven'
          break
        case VehicleState.Archivados:
          apiUrl += '/arc'
          break
        case VehicleState.Cotizables:
          apiUrl += '/cot'
          break

        case VehicleState.Consignables:
          apiUrl += '/con'
          break
        //POR AHORA: rrevisar ruta "/cot"
        case VehicleState.Reservables:
          apiUrl += '/cot'
          break
        case VehicleState.NotasVendibles:
          apiUrl += '/nvv'
          break
        //TODO: REVISAR
        case VehicleState.Creditables:
          apiUrl += '/nvv'
          break
        case VehicleState.Comprables:
          apiUrl += '/com'
          break
        case VehicleState.Negociables:
          apiUrl += '/neg'
          break
      }
      apiUrl += `/${organizationId}`

      break

    case AppPath.Clients:
      apiUrl = `${tempData.baseUrl}clients/${organizationId}`

      break
    case AppPath.Deals:
      apiUrl = `${tempData.baseUrl}deals`

      switch (index) {
        case DealState.EnCurso:
          apiUrl += '/enc'
          break

        case DealState.Completados:
          apiUrl += '/com'
          break
        case DealState.Cancelados:
          apiUrl += '/can'
          break
      }
      apiUrl += `/${organizationId}`
      break
  }

  if (external) {
    apiUrl += `?external=${external}`
  }

  return apiUrl
}
export const makeUrlImageShort = (img: string) => {
  return img === '' ? '' : `${tempData.baseUrl}picture/${img}?type=thumbnail&size=sm`
}
export const makeUrlPictureCrea = () => {
  const apiUrl = `${tempData.baseUrl}picture_crea`

  return apiUrl
}
export const makeUrlVehicleEdit = (mode: boolean | null): string => {
  const apiUrl = mode ? `${tempData.baseUrl}vehicle_edit` : `${tempData.baseUrl}vehicle_crea`

  return apiUrl
}
export const makeUrlVehicleExpensesPost = () => {
  const apiUrl = `${tempData.baseUrl}vehicle_expenses_crea`

  return apiUrl
}
export const makeUrlBodies = (): string => {
  const apiUrl = `${tempData.baseUrl}bodies`

  return apiUrl
}

export const makeUrlClient = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}client_detail/${id}`

  return apiUrl
}
export const makeUrlClientEdit = (): string => {
  const apiUrl = `${tempData.baseUrl}client_edit`

  return apiUrl
}
export const makeUrlClientCrea = (): string => {
  const apiUrl = `${tempData.baseUrl}client_crea`

  return apiUrl
}
export const makeUrlLogin = (): string => {
  const apiUrl = `${tempData.baseUrl}login`

  return apiUrl
}
export const makeUrlLoginProfile = (): string => {
  const url = new URL('login/profile', tempData.baseUrl)

  return url.href
}
export const makeUrlOrganization = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}organization/${id}`

  return apiUrl
}
export const makeUrlTemplate = (id: string, docType: AppPath): string => {
  let url

  if (docType == AppPath.Estimates) {
    url = 'template_est'
  } else if (docType == AppPath.Consignments) {
    url = 'template_con'
  } else if (docType == AppPath.Reservations) {
    url = 'template_res'
  } else {
    url = 'template_nvv'
  }

  const apiUrl = `${tempData.baseUrl}${url}/${id}`

  return apiUrl
}
export const makeUrlTemplateOrg = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}template_org/${id}`

  return apiUrl
}

export const makeUrlProfile = (user_id: string): string => {
  const apiUrl = `${tempData.baseUrl}profile/${user_id}`

  return apiUrl
}
export const makeUrlCredit = (organizationId: string, status: CreditState): string => {
  let url = 'credits'

  switch (status) {
    case CreditState.Enviados:
      url += '/env'
      break
    case CreditState.Aprobados:
      url += '/apr'
      break
    case CreditState.Tomados:
      url += '/tom'
      break
    case CreditState.Rechazados:
      url += '/rec'
      break
    case CreditState.NoTomados:
      url += '/not'
      break
  }
  const apiUrl = `${tempData.baseUrl}${url}/${organizationId}`

  return apiUrl
}

/**
 * Unified credits endpoint - Returns both manual and Autofin credits
 * @param organizationId Organization ID
 * @param status Credit state (Enviados, Aprobados, etc.)
 * @returns URL for unified credits endpoint
 */
export const makeUrlUnifiedCredit = (organizationId: string, status: CreditState): string => {
  const apiUrl = `${tempData.baseUrl}credits/unified/${organizationId}?status=${status}`

  return apiUrl
}

export const makeUrlCreditDetail = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}credit_detail/${id}`

  return apiUrl
}
export const makeUrlMessage = (organizationId: string, status: MessageState): string => {
  let url = 'messages'

  switch (status) {
    case MessageState.Consultas:
      url += '/con'
      break
    case MessageState.Otros:
      url += '/otr'
      break
    case MessageState.Procesados:
      url += '/pro'
      break
    case MessageState.Descartados:
      url += '/des'
      break
  }
  const apiUrl = `${tempData.baseUrl}${url}/${organizationId}`

  return apiUrl
}
export const makeUrlUserProfile = (organizationId: string, status: UserState): string => {
  let url = 'user_profiles'

  switch (status) {
    case UserState.Activo:
      url += '/act'
      break
    case UserState.Inactivo:
      url += '/ina'
      break
  }
  const apiUrl = `${tempData.baseUrl}${url}/${organizationId}`

  return apiUrl
}
export const makeUrlBranches = (organizationId: string, status: BranchState): string => {
  let url = 'branches'

  switch (status) {
    case BranchState.Activo:
      url += '/act'
      break
    case BranchState.Inactivo:
      url += '/ina'
      break
  }
  const apiUrl = `${tempData.baseUrl}${url}/${organizationId}`

  return apiUrl
}
export const makeUrlBranchDetail = (id: string) => {
  return `${tempData.baseUrl}branch_detail/${id}`
}
export const makeUrlBranchActivate = (): string => {
  return `${tempData.baseUrl}branch_activate`
}
export const makeUrlBranchEdit = (id: string): string => {
  return id === '0'
    ? `${tempData.baseUrl}branch_crea` // Si id es "0", es creación
    : `${tempData.baseUrl}branch_edit` // Si es otro valor, es edición
}

export const makeUrlYapoBrands = (): string => {
  const url = 'yapo_brands'

  const apiUrl = `${tempData.baseUrl}${url}`

  return apiUrl
}

export const makeUrlYapoTypes = (): string => {
  const url = 'type-translate-get'
  const apiUrl = `${yapoUrl}${url}`

  return apiUrl
}
export const makeUrlYapoBodies = (): string => {
  const url = 'body-translate-get'
  const apiUrl = `${yapoUrl}${url}`

  return apiUrl
}
export const makeUrlYapoYears = (): string => {
  const url = 'years-get'

  const apiUrl = `${yapoUrl}${url}`

  return apiUrl
}
export const makeUrlYapoFuel = (): string => {
  const url = 'fuel-translate-get'

  const apiUrl = `${yapoUrl}${url}`

  return apiUrl
}
export const makeUrlYapoGearbox = (): string => {
  const url = 'gearbox-translate-get'

  const apiUrl = `${yapoUrl}${url}`

  return apiUrl
}
export const makeUrlYapoLocalization = (): string => {
  const url = 'yapo_localization'

  const apiUrl = `${tempData.baseUrl}${url}`

  return apiUrl
}
export const makeUrlDeal = (organizationId: string, status: DealState): string => {
  let url = 'deals'

  switch (status) {
    case DealState.EnCurso:
      url += '/enc'
      break
    case DealState.Completados:
      url += '/com'
      break
    case DealState.Cancelados:
      url += '/can'
      break
  }
  const apiUrl = `${tempData.baseUrl}${url}/${organizationId}`

  return apiUrl
}
export const makeUrlDealDetail = (id: string): string => {
  return `${tempData.baseUrl}deal_detail/${id}`
}
export const makeUrlUserProfileDetail = (id: string): string => {
  return `${tempData.baseUrl}user_profile_detail/${id}`
}
export const makeUrlCreditVehCli = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}credit_vehcli?${params.toString()}`
}

export const makeUrlCreditEdit = (modificaSw: boolean): string => {
  return `${tempData.baseUrl}${modificaSw ? 'credit_edit' : 'credit_crea'}`
}
export const makeUrlTemplateGenEdit = (): string => {
  return `${tempData.baseUrl}template_edit/gen`
}

export const makeUrlDealEdit = (modificaSw: boolean): string => {
  return `${tempData.baseUrl}${modificaSw ? 'deal_edit' : 'deal_crea'}`
}
export const makeUrlPictureDelete = (): string => {
  return `${tempData.baseUrl}picture_delete`
}
export const makeUrlBrands = (): string => {
  const apiUrl = `${tempData.baseUrl}brands`

  return apiUrl
}

export const makeUrlYapoModels = (params: URLSearchParams): string => {
  return `${yapoUrl}models-get/?${params.toString()}`
}

export const makeUrlYapoPublish = (): string => {
  return `${yapoUrl}vehicle-publish`
}

export const makeUrlUserActivate = (): string => {
  return `${tempData.baseUrl}user_activate`
}
export const makeUrlProfileEdit = (): string => {
  return `${tempData.baseUrl}profile_edit`
}
export const makeUrlReservationVoid = (): string => {
  return `${tempData.baseUrl}reservation_void`
}
export const makeUrlReservationArchive = (): string => {
  return `${tempData.baseUrl}reservation_archive`
}
export const makeUrlSettlementVoid = (): string => {
  return `${tempData.baseUrl}settlement_void`
}
export const makeUrlVehicleArchive = (): string => {
  return `${tempData.baseUrl}vehicle_archive`
}
export const makeUrlVehicleRestore = (): string => {
  return `${tempData.baseUrl}vehicle_restore`
}
export const makeUrlDealCancel = (): string => {
  return `${tempData.baseUrl}deal_cancel`
}
export const makeUrlDealRestore = (): string => {
  return `${tempData.baseUrl}deal_restore`
}
export const makeUrlSalenotesDeal = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}salenotes_deal?${params.toString()}`
}
export const makeUrlDealComplete = (): string => {
  return `${tempData.baseUrl}deal_complete`
}
export const makeUrlDealAssign = (): string => {
  return `${tempData.baseUrl}deal_assign`
}
export const makeUrlMessageDetail = (id: string): string => {
  return `${tempData.baseUrl}message_detail/${id}`
}
export const makeUrlMessageEdit = () => {
  return `${tempData.baseUrl}message_edit`
}
export const makeUrlMessageAssign = () => {
  return `${tempData.baseUrl}message_assign`
}
export const makeUrlMessageDiscard = () => {
  return `${tempData.baseUrl}message_discard`
}
export const makeUrlEstimatesDeal = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}estimates_deal?${params.toString()}`
}
export const makeUrlReservationsDeal = (params: URLSearchParams): string => {
  return `${tempData.baseUrl}reservations_deal?${params.toString()}`
}
export const makeUrlTemplateConEdit = (): string => {
  return `${tempData.baseUrl}template_edit/con`
}
export const makeUrlTemplateConFull = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}template_con_full/${id}`

  return apiUrl
}
export const makeUrlTemplateDocFull = (id: string, path: AppPath): string => {
  let doc = ''

  if (path === AppPath.Reservations) {
    doc = 'res'
  } else if (path === AppPath.SaleNotes) {
    doc = 'nvv'
  } else {
    doc = 'est'
  }
  const apiUrl = `${tempData.baseUrl}template_${doc}_full/${id}`

  return apiUrl
}
export const makeUrlTemplateDocsEdit = (path: AppPath): string => {
  let doc = ''

  if (path === AppPath.Reservations) {
    doc = 'res'
  } else if (path === AppPath.SaleNotes) {
    doc = 'nvv'
  } else {
    doc = 'est'
  }

  return `${tempData.baseUrl}template_edit/${doc}`
}
export const makeUrlActivityDelete = () => {
  const apiUrl = `${tempData.baseUrl}activity_delete`

  return apiUrl
}
export const makeUrlModels = (): string => {
  const apiUrl = `${tempData.baseUrl}models`

  return apiUrl
}
export const makeUrlProfileCrea = (): string => {
  return `${tempData.baseUrl}profile_crea`
}
export const makeUrlToken = (id: string): string => {
  return `${tempData.baseUrl}token/${id}`
}
export const makeUrlUserActivateFirst = (): string => {
  return `${tempData.baseUrl}user_activate_first`
}
export const makeUrlMessageProcess = () => {
  return `${tempData.baseUrl}message_process`
}
export const makeUrlImagesReorder = (): string => {
  return `${tempData.baseUrl}images_reorder`
}
export const makeUrlUserPasswordReq = (): string => {
  const apiUrl = `${tempData.baseUrl}user_password_req`

  return apiUrl
}
export const makeUrlVehiclePublishLocal = (): string => {
  return `${tempData.baseUrl}vehicle_publish_local`
}
export const makeUrlMunicipalities = (): string => {
  return `${tempData.baseUrl}municipalities`
}
export const makeUrlRegionDetail = (id: string): string => {
  return `${tempData.baseUrl}region_detail/${id}`
}
export const makeUrlYapoSetPublished = () => {
  return `${tempData.baseUrl}yapo_set_published`
}
export const makeUrlChaTypes = (): string => {
  const url = 'type-translate-get'
  const apiUrl = `${chaUrl}${url}`

  return apiUrl
}
export const makeUrlChaBodies = (type?: string): string => {
  const url = 'bodystyles-get'
  const apiUrl = `${chaUrl}${url}`

  return type ? `${apiUrl}?type=${type}` : apiUrl
}
export const makeUrlChaBrands = (type?: string): string => {
  const url = 'brands-get'
  const apiUrl = `${chaUrl}${url}`

  return type ? `${apiUrl}?type=${type}` : apiUrl
}
export const makeUrlChaModels = (params: URLSearchParams, type?: string): string => {
  if (type) {
    params.append('type', type)
  }
  const url = `models-get/?${params.toString()}`
  const apiUrl = `${chaUrl}${url}`

  return apiUrl
}
export const makeUrlChaFuel = (): string => {
  const url = 'fueltypes-get'
  const apiUrl = `${chaUrl}${url}`

  return apiUrl
}
export const makeUrlChaGearbox = (): string => {
  const url = 'geartypes-get'
  const apiUrl = `${chaUrl}${url}`

  return apiUrl
}
export const makeUrlColor = (): string => {
  const url = 'colors-get'
  const apiUrl = `${chaUrl}${url}`

  return apiUrl
}
export const makeUrlChaPublish = (): string => {
  return `${chaUrl}vehicle-publish`
}
export const makeUrlChaUpdate = (): string => {
  return `${chaUrl}vehicle-update`
}
export const makeUrlChaProducts = (organizationId: string): string => {
  return `${chaUrl}products-get?organizationId=${encodeURIComponent(organizationId)}`
}
export const makeUrlChaVehicleTags = (): string => {
  return `${chaUrl}vehicle-tags`
}
export const makeUrlChaSetPublished = () => {
  return `${tempData.baseUrl}cha_set_published`
}
export const makeUrlImagesReorderAll = (params: URLSearchParams) => {
  return `${tempData.baseUrl}images_reorder_all?${params.toString()}`
}
export const makeUrlConsignmentVoid = (): string => {
  return `${tempData.baseUrl}consignment_void`
}
export const makeUrlYapoDelete = () => {
  return `${tempData.baseUrl}yapo_delete`
}
export const makeUrlClientDocs = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}client_detail_docs/${id}`

  return apiUrl
}
export const makeUrlChaDelete = () => {
  return `${tempData.baseUrl}cha_delete`
}
export const makeUrlConsignmentVehicle = (id: string): string => {
  return `${tempData.baseUrl}consignment_vehicle/${id}`
}
export const makeUrlOrganizationDelegatesCrea = () => {
  return `${tempData.baseUrl}organization_delegates_crea`
}
export const makeUrlOrganizationConsignmentDefaultsCrea = () => {
  return `${tempData.baseUrl}organization_consignment_defaults_crea`
}
export const makeUrlUserWebsitePromo = () => {
  return `${tempData.baseUrl}user_website_promo`
}
export const makeUrlPurchaseVehicle = (id: string): string => {
  return `${tempData.baseUrl}purchase_vehicle/${id}`
}
export const makeUrlSalenoteTradeIn = (plate: string): string => {
  return `${tempData.baseUrl}salenote_tradein/${plate}`
}
export const makeUrlSalenotesTasks = (id: string): string => {
  const apiUrl = `${tempData.baseUrl}salenotes_tasks/${id}`

  return apiUrl
}
export const makeUrlSalenoteTasksEdit = () => {
  return `${tempData.baseUrl}salenotes_tasks_edit`
}
export const makeUrlSalenoteTasksConfirm = () => {
  return `${tempData.baseUrl}salenote_tasks_confirm`
}
export const makeUrlMeliTypes = (): string => {
  const url = 'type-translate-get'
  const apiUrl = `${meliUrl}${url}`

  return apiUrl
}
export const makeUrlMeliCategoryAttr = (): string => {
  const url = 'category-attr'
  const apiUrl = `${meliUrl}${url}`

  return apiUrl
}
export const makeUrlMeliDirectCategoryAttr = (): string => {
  const url = 'direct-category-attr'
  const apiUrl = `${meliUrl}${url}`

  return apiUrl
}
export const makeUrlMeliStartVerifier = () => {
  return `${meliUrl}start-verifier`
}
export const makeUrlMeliStart = (state?: string, redirectUri?: string) => {
  const baseUrl = `${meliUrl}start`

  const params = []

  if (state) params.push(`state=${encodeURIComponent(state)}`)

  if (redirectUri) params.push(`redirect_uri=${encodeURIComponent(redirectUri)}`)

  const queryString = params.join('&')

  return queryString ? `${baseUrl}?${queryString}` : baseUrl
}
export const makeUrlMeliExchangeCode = () => {
  return `${meliUrl}exchange-code`
}
export const makeUrlMeliLogged = (profile: string) => {
  return `${meliUrl}logged/${profile}`
}
export const makeUrlMeliTokenRefresh = () => {
  return `${meliUrl}token-refresh`
}
export const makeUrlMeliPublish = (): string => {
  return `${meliUrl}vehicle-publish`
}
export const makeUrlMeliSetPublished = () => {
  return `${tempData.baseUrl}meli-set-published`
}
export const makeUrlMeliDelete = () => {
  return `${tempData.baseUrl}meli-delete`
}
export const makeUrlMeliUpdateData = () => {
  return `${meliUrl}vehicle-update-data`
}
export const makeUrlMeliUpdateDescription = () => {
  return `${meliUrl}vehicle-update-description`
}
export const makeUrlLinzeDelete = () => {
  return `${tempData.baseUrl}linze_delete`
}
export const makeUrlRenewToken = () => {
  return `${tempData.baseUrl}renew-token`
}

export const makeUrlVehicleVideoEdit = (): string => {
  return `${tempData.baseUrl}vehicle_edit/video-url`
}

export const makeUrlVideoCrea = (): string => {
  return `${tempData.baseUrl}video_crea`
}

export const makeUrlVideoStream = (fileId: string): string => {
  return `${tempData.baseUrl}video_stream/${fileId}`
}

export const makeUrlVideoDelete = (): string => {
  return `${tempData.baseUrl}video_delete`
}

export const makeUrlVideoPresignedUrl = (vehicleId: string): string => {
  return `${tempData.baseUrl}video_presigned_url/${vehicleId}`
}

// Publication data endpoints
export const makeUrlSavePublicationData = (vehicleId: string, platform: string): string => {
  return `${tempData.baseUrl}publication-data/${vehicleId}/${platform}`
}

export const makeUrlLoadPublicationData = (vehicleId: string, platform: string): string => {
  return `${tempData.baseUrl}publication-data/${vehicleId}/${platform}`
}

// Linze endpoints
export const makeUrlLinzeDraft = (vehicleId: string): string => {
  return `${tempData.baseUrl}linze/draft/${vehicleId}`
}

export const makeUrlLinzePublish = (vehicleId: string): string => {
  return `${tempData.baseUrl}linze/publish/${vehicleId}`
}

export const makeUrlLinzeUpdate = (vehicleId: string): string => {
  return `${tempData.baseUrl}linze/update/${vehicleId}`
}

export const makeUrlLinzeSold = (vehicleId: string): string => {
  return `${tempData.baseUrl}linze/sold/${vehicleId}`
}

// ─── Transfers (Transfiero Online + Mercado Pago) ───
export const makeUrlTransfers = (organizationId: string): string => {
  return `${tempData.baseUrl}transfers/${organizationId}`
}
export const makeUrlTransfer = (id: string): string => {
  return `${tempData.baseUrl}transfer/${id}`
}
export const makeUrlTransferInit = (): string => {
  return `${tempData.baseUrl}transfer_init`
}
export const makeUrlTransferDocuments = (): string => {
  return `${tempData.baseUrl}transfer_documents`
}
export const makeUrlTransferSubmit = (): string => {
  return `${tempData.baseUrl}transfer_submit`
}
export const makeUrlTransferVoid = (): string => {
  return `${tempData.baseUrl}transfer_void`
}
export const makeUrlTransfersSse = (organizationId: string): string => {
  return `${tempData.baseUrl}transfers/sse/${organizationId}`
}
export const makeUrlTransferPreview = (id: string): string => {
  return `${tempData.baseUrl}transfer_preview/${id}`
}
export const makeUrlTransferPayment = (): string => {
  return `${tempData.baseUrl}transfer_payment/payment-link`
}

// Export base URL for components that need it
export const getApiBaseUrl = (): string => {
  return tempData.baseUrl.replace(/\/api\/$/, '')
}
